import client from '@js/client'
import resources from '@js/resources'
import { snakeKeyToCamelKey } from '@js/str-utils'

const keys = ['experienceTypes', 'jobCategories', 'mediaTypes'];

const getDefaultState = () => {
  return {
    params: keys.reduce((result, key) => Object.assign(result, {[key]: []}), {}),
  };
};

const tenantParams = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    experienceTypes: state => state.params.experienceTypes,
    jobCategories: state => state.params.jobCategories,
    getIdByName: state => (key, name) => {
      const index = state.params[key].filter(
        elem => elem.name).findIndex(
          elem => elem.name === name);
      return index < 0 ? null : state.params[key][index].id;
    },
  },
  mutations: {
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
    setParam (state, { data, key }) {
      state.params[key] = data.reduce((result, elem) => {
        delete elem['tenant'];
        result.push(snakeKeyToCamelKey(elem));
        return result;
      }, []);
    },
    setExperienceTypes (state, data) {
      state.experienceTypes = data;
    },
    setJobCategories (state, data) {
      state.jobCategories = data;
    },
    setMediaTypes (state, data) {
      state.mediaTypes = data;
    },
  },
  actions: {
    async fetchAllTenantParams({ state, dispatch }) {
      for (const key of Object.keys(state.params)) {
        await dispatch('fetchTenantParam', key);
      }
    },
    async fetchTenantParam({ state, commit, rootGetters }, key) {
      const domain = await rootGetters['tenant/getTenantDomain'];
      const res = await client.get(resources[key](domain));
      await commit('setParam', { data: res.data, key: key });
      return res;
    },
  },
};

export default tenantParams;
